module.exports = __webpack_public_path__ + "static/media/pdf.9071a5ec.svg";